module.exports = __webpack_public_path__ + "ce1a1d1b.png";